import groq from 'groq'
import thumbField from '../fields/thumb'

export default id => groq`
  *[_id == "${id}" || _type == "labResults"][0]{
    pageTitle,
    subTitle,
    cbd,
    labResults[]{
      ...,
      defined(coa) => {
        "coa": {
          "url": coa.asset->url
        }
      },
      product-> {
        title,
        ${thumbField}
      }
    }
  }
`
